/*
 * $Id:: App.js 2021/03/02 03:04 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { globals as globalsSlice } from './app/globalsSlice';
import { error as giLiteralsError, literals as literalsData } from './app/literalsSlice';
import Footer from './components/Footer';
import FooterMobile from './components/Footer/FooterMobile';
import Header from './components/Header/Header';
import Notification from './components/Notification';
import Sidebar from './components/Sidebar';
import { RenderRoutes, routes, userAreaTheme } from './config';
import { ThemeProvider } from './providers';
import Typography from '@material-ui/core/Typography';
import { t } from './providers';

const useStyles = makeStyles((_theme) => ({
    content: {
        boxShadow: '0px 1px 4px 1px #c4c4d2',
        marginTop: '84px',
        minHeight: 'calc(100vh - 170px - 85px)', // 100vh - footerHeight - headerHeight
        backgroundColor: '#FAFAFA',
        '@media (max-width:960px)': {
            minHeight: 'calc(100vh - 490px - 85px)',
        },
    },
    loading: {
        margin: '0 auto',
        textAlign: 'center',
        padding: '50px',
    },
    globalLoading: {
        margin: '0 auto',
        top: '40%',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    mainPage: {
        display: 'flex',
        flexFlow: 'row nowrap',
        backgroundColor: '#FAFAFA',
        height: '100%',
        // minHeight: '100vh',
        paddingTop: '3px',
        '@media (max-width:960px)': {
            padding: '35px 20px',
        },
    },
    sidebarContainer: {
        padding: '0px',
        borderRight: '1px solid #CDCDCD',
        // marginTop: '35px',
        backgroundColor: '#FAFAFA',
        width: '300px',
        '@media (max-width:960px)': {
            visibility: 'hidden',
            width: '0',
            minWidth: '0',
            padding: '0',
        },
    },
    container: {
        width: '100%',
        height: '100%',
        maxWidth: 'calc(100% - 373px)',
        padding: '48px 24px 48px 48px',
        minHeight: '535px',
        '@media (max-width:960px)': {
            minWidth: '70%',
            maxWidth: 'unset',
            padding: '5px 24px 32.12px 24px',
        },
        '@media (max-width:660px)': {
            minWidth: '70%',
            maxWidth: 'unset',
            padding: '5px 10px 32.12px 10px',
        },
    },
    containerFullPage: {
        width: '100%',
        height: '100%',
        maxWidth: 'calc(100% - 72px)',
        padding: '48px 24px 48px 48px',
        minHeight: '520px',
        '@media (max-width:960px)': {
            minWidth: '70%',
            maxWidth: 'unset',
        },
    },
}));

function App() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const literals = useSelector(literalsData);
    const literalsError = useSelector(giLiteralsError);
    const globals = useSelector(globalsSlice);
    const isTablet = useMediaQuery('(max-width:960px)');
    const pageUrl = window.location.href;
    const [showMenu, setShowMenu] = useState(pageUrl.indexOf('error') > -1 ? false : true);

    const { globalLoading } = globals;
    useEffect(() => {
        dispatch({ type: 'globals/fetchGlobals', payload: null });
    }, [dispatch]);

    const changeMenuVisibility = (state) => {
        setShowMenu(state);
        const burgerMenu = document.getElementById('burgerMenuBtn');
        burgerMenu.focus();
    };

    let render = '';
    const template = (
        <ThemeProvider theme={userAreaTheme}>
            <Router basename={process.env.REACT_APP_BASENAME}>
                <Grid container>
                    <Grid item xs={12}>
                        <Header smallDevice={isTablet} showMenu={showMenu} setShowMenu={changeMenuVisibility} />
                    </Grid>
                    <Grid item xs={12} className={classes.content}>
                        <div className={classes.mainPage}>
                            {!isTablet && showMenu && (
                                <Box width={300} className={classes.sidebarContainer} id="sidebar-menu-container" aria-labelledby="burgerMenuBtn">
                                    <Sidebar showMenu={showMenu} setShowMenu={changeMenuVisibility} />
                                </Box>
                            )}
                            <main className={showMenu ? classes.container : classes.containerFullPage}>
                                <RenderRoutes routes={routes} />
                            </main>
                        </div>
                    </Grid>
                    <Grid item xs={12} style={{ zIndex: '999' }}>
                        <footer>{isTablet ? <FooterMobile /> : <Footer />}</footer>
                    </Grid>
                </Grid>
                <Notification />
            </Router>
        </ThemeProvider>
    );

    if (!literals || globalLoading || literalsError) {
        render = (
            <div className={classes.loading}>
                <CircularProgress aria-hidden="true" />
                <Typography variant="srOnly" role="alert">
                    {t('loading.text')}
                </Typography>
            </div>
        );
    } else {
        render = template;
    }

    return <>{render}</>;
}

export default App;
